import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/Routes/PrivateRoutes";
import PublicRoute from "./components/Routes/PublicRoute";
import FullScreenPrivateRoute from "./components/Routes/FullScreenPrivateRoute";
import { routes } from "./configs/constants/routes";
import ActivateAccountPage from "./pages/ActivateAccountPage/ActivateAccountPage";
import CreateConsultantsPage from "./pages/Consultants/ConsultantsCreatePage";
import ConsultantsDetailsPage from "./pages/Consultants/ConsultantsDetailsPage";
import ConsultantsListVirtualizedPage from "./pages/Consultants/ConsultantsListVirtualizedPage";
import ContractsCreatePage from "./pages/Contracts/ContractCreatePage";
import ContractDetailsPage from "./pages/Contracts/ContractDetailsPage";
import ContractsListPage from "./pages/Contracts/ContractsListPage";
import CorporateGroupsPage from "./pages/Customers/CorporateGroupsPage";
import CustomerCreatePage from "./pages/Customers/CustomerCreatePage";
import CustomerDetailsPage from "./pages/Customers/CustomerDetailsPage";
import CustomersListVirtualizedPage from "./pages/Customers/CustomersListVirtualizedPage";
import CustomerUsersListPage from "./pages/Customers/CustomerUsersListPage";
import CustomerUserForm from "./pages/Customers/CustomerUserForm";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import InvoiceBatchFormPage from "./pages/InvoiceBatches/InvoiceBatchFormPage";
import InvoiceBatchListPage from "./pages/InvoiceBatches/InvoiceBatchListPage";
import InvoiceJournalPage from "./pages/InvoiceBatches/InvoiceJournalPage";
import InvoiceDetailsPage from "./pages/Invoices/InvoiceDetailsPage";
import InvoiceListPage from "./pages/Invoices/InvoiceListPage";
import JobReportDetails from "./pages/JobReports/JobReportDetails";
import JobReportsListPage from "./pages/JobReports/JobReportsList";
import JobCreatePage from "./pages/Jobs/JobCreatePage";
import JobDetailsPage from "./pages/Jobs/JobDetailsPage";
import JobListPage from "./pages/Jobs/JobListPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import LogoutPage from "./pages/Logout/Logout";

import RecruitmentCreatePage from "./pages/Recruitment/RecruitmentCreatePage";
import RecruitmentDetailsPage from "./pages/Recruitment/RecruitmentDetailsPage";
import RecruitmentListPage from "./pages/Recruitment/RecruitmentListPage";

import ResetPassword from "./pages/ResetPassword/ResetPassword";
import SalaryBatchPage from "./pages/Salary/SalaryBatchPage";
import SalaryJournalPage from "./pages/Salary/SalaryJournalPage";
import SalaryListPage from "./pages/Salary/SalaryListPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import TimeReportsPage from "./pages/TimeReports/TimeReportsPage";
import UserInvitePage from "./pages/Users/UserInvitePage";
import UsersListPage from "./pages/Users/UsersListPage";
import UsersProfile from "./pages/Users/UsersProfile";
import CustomersReportPage from "./pages/Reports/CustomersReport";
import ConsultantsReportPage from "./pages/Reports/ConsultantsReport";
import CandidatesReportPage from "./pages/Reports/CandidatesReport";
import ConsultantsWorkedHoursReportPage from "./pages/Reports/ConsultantsWorkedHoursReport";
import SoldHoursAndRevenueReportPage from "./pages/Reports/SoldHoursAndRevenueReport";

import KPIDashboardPage from "./pages/KPI/KPI";
import ReportBuilderPage from "./pages/ReportBuilder/ReportBuilderPage";
import PublicReportPage from "./pages/PublicReport/PublicReportPage";
import ComponentShowcasePage from "./pages/ComponentShowcase/ComponentShowcasePage";

import SchedulePage from "./pages/Overview/SchedulePage";
import CustomerContactsReportPage from "./pages/Reports/CustomerContactsReport";
import NotificationLogsPage from "./pages/NotificationLogs/NotificationLogsPage";
import ApiLogsPage from "./pages/ApiLogs/ApiLogsPage";
import FeedbackPage from "./pages/FeedbackPage/FeedbackPage";
import NotFoundComponent from "./components/Shared/NotFoundComponent/NotFoundComponent";
import ResponseTimeStatsPage from "./pages/ResponseTimeStats/ResponseTimeStatsPage";
import DocumentsPage from "./pages/Documents/DocumentsPage";
import SSETestPage from "./pages/SSETest/SSETestPage";
import DocumentUploadPage from "./pages/Documents/DocumentUploadPage";
import DocumentLinkPage from "./pages/Documents/DocumentLinkPage";
import DocumentEditPage from "./pages/Documents/DocumentEditPage";
import DocumentLinkEditPage from "./pages/Documents/DocumentLinkEditPage";
import ConsultantCollectiveAgreements from "./pages/Consultants/CollectiveAgreementsListPage";
import CollectiveAgreementCreatePage from "./pages/Consultants/CollectiveAgreementCreatePage";
import CollectiveAgreementEditPage from "./pages/Consultants/CollectiveAgreementEditPage";

export default () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route
					path={routes.LOGIN}
					element={
						<PublicRoute>
							<LoginPage />
						</PublicRoute>
					}
				/>
				<Route
					path={routes.HOME}
					element={
						<PublicRoute>
							<LoginPage />
						</PublicRoute>
					}
				/>
				<Route
					path={routes.ACTIVATE}
					element={
						<PublicRoute>
							<ActivateAccountPage />
						</PublicRoute>
					}
				/>
				<Route
					path={routes.FORGOT_PASSWORD}
					element={
						<PublicRoute>
							<ForgotPassword />
						</PublicRoute>
					}
				/>
				<Route
					path={routes.RESET_PASSWORD}
					element={
						<PublicRoute>
							<ResetPassword />
						</PublicRoute>
					}
				/>

				<Route
					path={routes.SCHEDULE}
					element={
						<PrivateRoute>
							<SchedulePage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.DOCUMENTS}
					element={
						<PrivateRoute>
							<DocumentsPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.DOCUMENT_UPLOAD}
					element={
						<PrivateRoute>
							<DocumentUploadPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.DOCUMENT_EDIT + "/*"}
					element={
						<PrivateRoute>
							<DocumentEditPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.DOCUMENT_EDIT_LINK + "/*"}
					element={
						<PrivateRoute>
							<DocumentLinkEditPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.LINK_UPLOAD}
					element={
						<PrivateRoute>
							<DocumentLinkPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.JOBS}
					element={
						<PrivateRoute>
							<JobListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.JOB_CREATE}
					element={
						<PrivateRoute>
							<JobCreatePage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.JOB_DETAILS + "/*"}
					element={
						<PrivateRoute>
							<JobDetailsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.TIME_REPORTS}
					element={
						<PrivateRoute>
							<TimeReportsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CONSULTANTS}
					element={
						<PrivateRoute>
							<ConsultantsListVirtualizedPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.AGREEMENT}
					element={
						<PrivateRoute>
							<ConsultantCollectiveAgreements />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CREATE_AGREEMENT}
					element={
						<PrivateRoute>
							<CollectiveAgreementCreatePage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.EDIT_AGREEMENT}
					element={
						<PrivateRoute>
							<CollectiveAgreementEditPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CONSULTANTS_NEW}
					element={
						<PrivateRoute>
							<CreateConsultantsPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CONSULTANTS_DETAILS + "/*"}
					element={
						<PrivateRoute>
							<ConsultantsDetailsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CUSTOMERS}
					element={
						<PrivateRoute>
							<CustomersListVirtualizedPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CUSTOMER_CORPORATE_GROUPS}
					element={
						<PrivateRoute>
							<CorporateGroupsPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CUSTOMER_USERS_LIST}
					element={
						<PrivateRoute>
							<CustomerUsersListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CUSTOMER_CREATE}
					element={
						<PrivateRoute>
							<CustomerCreatePage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CUSTOMER_USER_CREATE}
					element={
						<PrivateRoute>
							<CustomerUserForm />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CUSTOMER_USER_EDIT}
					element={
						<PrivateRoute>
							<CustomerUserForm />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CUSTOMER_DETAILS + "/*"}
					element={
						<PrivateRoute>
							<CustomerDetailsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CONTRACTS}
					element={
						<PrivateRoute>
							<ContractsListPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CONTRACTS_CREATE}
					element={
						<PrivateRoute>
							<ContractsCreatePage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CONTRACT_DETAILS + "/*"}
					element={
						<PrivateRoute>
							<ContractDetailsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.RECRUITMENT}
					element={
						<PrivateRoute>
							<RecruitmentListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.RECRUITMENT_CREATE}
					element={
						<PrivateRoute>
							<RecruitmentCreatePage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.RECRUITMENT_DETAILS + "/*"}
					element={
						<PrivateRoute>
							<RecruitmentDetailsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.INVOICES}
					element={
						<PrivateRoute>
							<InvoiceListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.INVOICE_DETAILS}
					element={
						<PrivateRoute>
							<InvoiceDetailsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.INVOICE_BATCHES}
					element={
						<PrivateRoute>
							<InvoiceBatchListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.INVOICE_BATCH_DETAILS}
					element={
						<PrivateRoute>
							{/* Keyed apart from the create route: both render the same
							    page at the same tree position, so without keys a jump
							    from a batch to "Ny körning med samma urval" would keep
							    the old batch in state */}
							<InvoiceBatchFormPage key="details" />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.INVOICE_BATCH_CREATE}
					element={
						<PrivateRoute>
							<InvoiceBatchFormPage key="create" />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.INVOICE_JOURNAL}
					element={
						<PrivateRoute>
							<InvoiceJournalPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.SALARY}
					element={
						<PrivateRoute>
							<SalaryListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.SALARY_JOURNAL}
					element={
						<PrivateRoute>
							<SalaryJournalPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.SALARY_NEW_BATCH}
					element={
						<PrivateRoute>
							<SalaryBatchPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.SALARY_BATCH_DETAILS}
					element={
						<PrivateRoute>
							<SalaryBatchPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.SETTINGS + "/*"}
					element={
						<PrivateRoute>
							<SettingsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.INTERNAL_USERS}
					element={
						<PrivateRoute>
							<UsersListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.INTERNAL_USERS_INVITE}
					element={
						<PrivateRoute>
							<UserInvitePage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.INTERNAL_USER_PROFILE}
					element={
						<PrivateRoute>
							<UsersProfile />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.JOB_REPORTS}
					element={
						<PrivateRoute>
							<JobReportsListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.JOB_REPORT_DETAILS}
					element={
						<PrivateRoute>
							<JobReportDetails />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CUSTOMERS_REPORT}
					element={
						<PrivateRoute>
							<CustomersReportPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CONSULTANTS_REPORT}
					element={
						<PrivateRoute>
							<ConsultantsReportPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.CANDIDATES_REPORT}
					element={
						<PrivateRoute>
							<CandidatesReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CUSTOMERS_REPORT}
					element={
						<PrivateRoute>
							<CustomersReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CUSTOMER_CONTACTS_REPORT}
					element={
						<PrivateRoute>
							<CustomerContactsReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CONSULTANTS_REPORT}
					element={
						<PrivateRoute>
							<ConsultantsReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CANDIDATES_REPORT}
					element={
						<PrivateRoute>
							<CandidatesReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.CONSULTANTS_WORKED_HOURS_REPORT}
					element={
						<PrivateRoute>
							<ConsultantsWorkedHoursReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.SOLD_HOURS_AND_REVENUE_REPORT}
					element={
						<PrivateRoute>
							<SoldHoursAndRevenueReportPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.NOTIF_LOGS}
					element={
						<PrivateRoute>
							<NotificationLogsPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.API_LOGS}
					element={
						<PrivateRoute>
							<ApiLogsPage />
						</PrivateRoute>
					}
				/>

				<Route path={routes.PUBLIC_REPORT} element={<PublicReportPage />} />
				<Route
					path={routes.REPORT_BUILDER}
					element={
						<PrivateRoute>
							<ReportBuilderPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.KPI_DASHBOARD}
					element={
						<PrivateRoute>
							<KPIDashboardPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.REPSONSE_TIME_STATS}
					element={
						<PrivateRoute>
							<ResponseTimeStatsPage />
						</PrivateRoute>
					}
				/>
				<Route
					path={routes.SSE_TEST}
					element={
						<PrivateRoute>
							<SSETestPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.COMPONENT_SHOWCASE}
					element={
						<FullScreenPrivateRoute>
							<ComponentShowcasePage />
						</FullScreenPrivateRoute>
					}
				/>

				<Route
					path={routes.FEEDBACK_REPORT}
					element={
						<PrivateRoute>
							<FeedbackPage />
						</PrivateRoute>
					}
				/>

				<Route
					path={routes.LOGOUT}
					element={
						<PublicRoute>
							<LogoutPage />
						</PublicRoute>
					}
				/>
				<Route path="*" element={<NotFoundComponent />} />
			</Routes>
		</BrowserRouter>
	);
};

export const ROOT = routes.LOGIN;
